import PropTypes from 'prop-types'
import React from 'react'

const Checkbox = ({
  name,
  value,
  label = 'checkboxItem',
  isChecked,
  onChanged,
}) => {
  return (
    <label className="flex items-center">
      <input
        className="w-4 h-4"
        type="checkbox"
        name={name}
        value={value}
        checked={isChecked}
        onChange={(_) => onChanged()}
      />
      <span className="ml-3">{label}</span>
    </label>
  )
}
Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onChanged: PropTypes.func.isRequired,
}

export default Checkbox;
